import { Metrics, Fonts } from "../../Themes";
import styled from "styled-components";

const styles = {
    formContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        flexGrow: 1
    },
    nameContainer: {
        display: "flex"
    },
    fieldContainer: {
        marginBottom: Metrics.margin.large
    },
    buttonContainer: {
        marginBottom: Metrics.margin.large,
        display: 'flex',
        justifyContent: 'space-between'
    },
    title: {
       ...Fonts.titleFonts 
    },
    errorMessage: {
        ...Fonts.errorMessage
    }
}

export const Link = styled.p`
    color: blue;
    text-align: left;
    margin-top: 10px;
    cursor: pointer;
    &:hover {
        text-decoration: underline
    }
`; 

export default styles 